import React from "react";
import { Link } from "react-router-dom";
import { ArrowRight, Home as HomeIcon } from "lucide-react";
import { useSeo } from "../lib/useSeo";
import LeadCta from "../components/leads/LeadCta";
import { ALL_LEAD_TYPES } from "../components/leads/leadConfig";

const Vastgoeddiensten = () => {
  useSeo({
    title: "Vastgoeddiensten — gratis waardebepaling, hypotheekadvies & meer | WoningAlert",
    description: "Vraag gratis en vrijblijvend advies van lokale vastgoedprofessionals — waardebepaling, hypotheek, aankoopmakelaar, taxatie, bouwkundige keuring, verhuizing en meer.",
    path: "/vastgoeddiensten",
  });

  return (
    <div className="min-h-screen bg-slate-50 pb-20">
      <section className="bg-navy pb-12 pt-10 text-white sm:pb-16 sm:pt-14">
        <div className="mx-auto max-w-5xl px-4 sm:px-6">
          <h1 className="font-display text-3xl font-extrabold leading-tight sm:text-5xl">Vastgoeddiensten</h1>
          <p className="mt-3 max-w-2xl text-sm text-white/80 sm:text-base">
            Gratis en vrijblijvend advies van lokale vastgoedprofessionals. Van waardebepaling tot verhuizing — alles op één plek.
          </p>
        </div>
      </section>

      <section className="mx-auto -mt-8 max-w-3xl px-4 sm:px-6">
        <Link
          to="/mijn-woning-verkopen"
          data-testid="particulier-sell-cta"
          className="group mb-4 flex items-center justify-between gap-4 rounded-3xl bg-gradient-to-br from-orange-500 to-orange-600 p-5 text-white shadow-md transition-transform hover:scale-[1.01] sm:p-6"
        >
          <div className="flex items-start gap-3 sm:gap-4">
            <span className="flex h-11 w-11 shrink-0 items-center justify-center rounded-2xl bg-white/20"><HomeIcon size={20} /></span>
            <div>
              <h3 className="font-display text-lg font-extrabold sm:text-xl">Verkoop je eigen woning</h3>
              <p className="mt-1 text-sm text-white/90">Als particulier: gratis plaatsen, geen bemiddelingskosten.</p>
            </div>
          </div>
          <span className="hidden items-center gap-1 text-sm font-semibold sm:inline-flex">Starten <ArrowRight size={14} /></span>
        </Link>

        <div className="grid gap-4">
          {ALL_LEAD_TYPES.map((t) => (
            <LeadCta key={t} type={t} />
          ))}
        </div>
      </section>
    </div>
  );
};

export default Vastgoeddiensten;
